<template>
  <div class="ts-h-screen ts-w-screen ts-flex ts-flex-col qr-code-page">
    <div class="ts-flex ts-items-center ts-py-2 header ts-shadow-md ts-px-4">
      <img
        class="ts-flex ts-items-center ts-justify-start ts-object-cover"
        :src="logo"
        style="width: 13%"
      />
      <span class="ts-flex-grow"></span>
      <img
        class="ts-flex ts-items-center ts-justify-center ts-object-cover"
        :src="companyLatter"
        style="width: 70%"
      />
      <span class="ts-flex-grow"></span>
    </div>
    <div
      class="ts-flex ts-items-center ts-py-2 sub-header ts-shadow-md font-khmer-moul"
    >
      <div v-if="isValidQr"><b>ទិន្នន័យបង្ហាញព័ត៌មាននិស្សិត</b></div>
      <div v-else><b>អ្នកក្លែង Barcode នឹងត្រូវផ្តន្ទាទោសតាមច្បាប់</b></div>
    </div>
    <div class="col-md-12 mt-4">
      <div class="box-row" v-if="isValidQr">
        <div class="box-container">
          <a href="#">ប្រវត្តិរូបនិស្សិត</a>
        </div>
        <div class="box-container">
          <a href="#">ពិន្ទុរបស់និស្សិត ប្រចាំឆមាស</a>
        </div>
        <div class="box-container">
          <a href="#">គល់បញ្ជីប្រឡងចូល</a>
        </div>
        <div class="box-container">
          <a href="#">គល់បញ្ជីប្រលងប្រឡង បញ្ជប់កាសិក្សា</a>
        </div>
        <div class="box-container">
          <a href="#">ព្រឺត្តបត្រពិន្ទុ</a>
        </div>
        <div class="box-container">
          <a href="#">វីញ្ញាបនបត្រ បណ្ដោះអាសន្ន</a>
        </div>
        <div class="box-container">
          <a href="#">សញ្ញាបត្រ បរិញ្ញាបត្ររង/ បរិញ្ញាបត្រ/ជាន់ខ្ពស់</a>
        </div>
        <div class="box-container">
          <a href="#">លិខិតបញ្ជាក់ការ សិក្សា</a>
        </div>
      </div>
      <div v-else class="ts-text-center">
        <h3 class="ts-pb-3 font-bold">
          <b>សូមស្គែន Barcode ម្ដងទៀត!!</b>
        </h3>
      </div>
    </div>

  </div>
</template>
<script>
import { isEmpty } from 'lodash'
import PageOptions from '../config/PageOptions.vue'

export default {
  name: 'barcdeDisplayCertificate',
  data () {
    return {
      companyLatter: require('@/assets/bti-company-letter.png'),
      logo: require('@/assets/bti-logo.png'),
      resources: null,
      token: null
    }
  },
  created () {
    this.logout()
    const token = this.$route.query.token
    this.token = token
    PageOptions.pageEmpty = true
    document.body.className = 'bg-white'
    this.$root.$i18n.locale = 'kh'
  },
  beforeRouteLeave (to, from, next) {
    PageOptions.pageEmpty = false
    next()
  },
  computed: {
    isValidQr () {
      return isEmpty(this.resources)
    }
  },
  methods: {
    async logout () {
      await this.$store.dispatch('logout')
    },
    fetchData () {
      this.resources = null
      this.$store
        .dispatch('certificateOperationPrint/barCodeScan', {
          token: this.token
        })
        .then(response => {
          this.resources = response
        })
        .catch(error => {})
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.fetchData()
    })
  }
}
</script>
<style scoped>
@media screen and (max-width: 819px) {
  .qr-code-page {
    /* background-image: url('../assets/background.png'); */
    background-blend-mode: multiply;
    background-color: #f4f5f4;
    margin: auto;
  }
  .box-container {
    width: 48%;
    height: 120px;
    margin: 1%;
    background-color: #cf7a36;
    border: 4px solid #4573c4;
    display: flex;
  }
}
@media all and (min-width: 820px) {
  .qr-code-page {
    /* background-image: url('../assets/background.png'); */
    background-blend-mode: multiply;
    background-color: #f4f5f4;
    margin: auto;
    width: 50%;
  }
  .box-container {
    width: 31.33%;
    height: 120px;
    margin: 1%;
    background-color: #cf7a36;
    border: 4px solid #4573c4;
    display: flex;
  }
}

.header {
  background: #5e0718;
}
.sub-header {
  background: #f8961c;
  color: #a4301d;
  padding: 10px 5px;
}
.font-khmer-moul {
  font-family: 'Khmer OS Muol Light';
}
.btn.btn-sm {
  font-size: 12px;
  line-height: 16px;
  padding: 5px 50px;
}
table {
  width: 98%;
  border-collapse: collapse;
  font-family: 'Khmer OS Battambang';
  background-color: #fff;
}
td {
  border: 1px rgb(139, 139, 139) solid;
  padding: 6px 3px;
  font-size: 12px;
  text-align: left;
  border-color: #32a1ce;
}
.text {
  padding-top: 30px;
  font-size: 25px;
  color: #271cd4;
  font-weight: bold;
  font-family: 'Khmer OS Battambang';
}
.box-row {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
}
.box-container a {
  color: #0000cc;
  font-size: 18px;
  font-weight: 700;
  align-items: center;
  text-align: center;
  display: flex;
  margin: auto;
}

</style>
